<template>
    <v-row>
        <CreateEditOwnerAdviser v-model="showCreateEditOwnerAdviser"></CreateEditOwnerAdviser>
        <v-col cols="12">
            <v-card>
                <v-tabs v-model="tab" background-color="abadPrimary" dark slider-color="cremita">
                    <v-tab style="text-transform: none">
                        <v-badge :color="tabsState[0] ? 'success' : 'error'">
                            <template #badge>
                                <v-icon>{{tabsState[0] ? 'check' : 'clear'}}</v-icon>
                            </template>
                            Datos Inmueble
                        </v-badge>
                    </v-tab>

                    <v-tab style="text-transform: none">
                        <v-badge :color="tabsState[1] ? 'success' : 'error'">
                            <template #badge>
                                <v-icon>{{tabsState[1] ? 'check' : 'clear'}}</v-icon>
                            </template>
                            Localización
                        </v-badge>
                    </v-tab>

                    <v-tab style="text-transform: none">
                        <v-badge :color="tabsState[2] ? 'success' : 'error'">
                            <template #badge>
                                <v-icon>{{tabsState[2] ? 'check' : 'clear'}}</v-icon>
                            </template>
                            Características internas
                        </v-badge>
                    </v-tab>

                    <v-tab style="text-transform: none">
                        <v-badge :color="tabsState[3] ? 'success' : 'error'">
                            <template #badge>
                                <v-icon>{{tabsState[3] ? 'check' : 'clear'}}</v-icon>
                            </template>
                            Áreas Comunes
                        </v-badge>
                    </v-tab>

                    <v-tab style="text-transform: none">
                        <v-badge :color="tabsState[4] ? 'success' : 'error'">
                            <template #badge>
                                <v-icon>{{tabsState[4] ? 'check' : 'clear'}}</v-icon>
                            </template>
                            Fotos y Videos
                        </v-badge>
                    </v-tab>

                    <v-tab style="text-transform: none">
                        <v-badge :color="tabsState[5] ? 'success' : 'error'">
                            <template #badge>
                                <v-icon>{{tabsState[5] ? 'check' : 'clear'}}</v-icon>
                            </template>
                            Portales
                        </v-badge>
                    </v-tab>

                    <v-tab style="text-transform: none">
                        <v-badge :color="tabsState[6] ? 'success' : 'error'">
                            <template #badge>
                                <v-icon>{{tabsState[6] ? 'check' : 'clear'}}</v-icon>
                            </template>
                            Sitios de interés
                        </v-badge>
                    </v-tab>

                    <v-tab style="text-transform: none">
                        Publicar Propiedad
                    </v-tab>

                    <v-tab style="text-transform: none">
                        Despublicar Propiedad
                    </v-tab>

                    <v-tab-item>
                        <v-card text>
                            <v-card-text>
                                <DatosDelInmueble @createNewOwner="showCreateEditOwnerAdviser = true"
                                                  @updateStateForm="updateStateForm({tab: 0, value: $event})">
                                </DatosDelInmueble>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card text>
                            <v-card-text>
                                <Localizacion @updateStateForm="updateStateForm({tab: 1, value: $event})">
                                </Localizacion>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card text>
                            <v-card-text>
                                <CaracteristicasInternas @updateStateForm="updateStateForm({tab: 2, value: $event})">
                                </CaracteristicasInternas>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card text>
                            <v-card-text>
                                <AreasComunes @updateStateForm="updateStateForm({tab: 3, value: $event})">
                                </AreasComunes>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card text>
                            <v-card-text>
                                <FotosVideos @updateStateForm="updateStateForm({tab: 4, value: $event})">
                                </FotosVideos>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card text>
                            <v-card-text>
                                <Portales @updateStateForm="updateStateForm({tab: 5, value: $event})">
                                </Portales>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card text>
                            <v-card-text>
                                <SitiosDeInteres @updateStateForm="updateStateForm({tab: 6, value: $event})"></SitiosDeInteres>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card text>
                            <v-card-text>
                                <PublicarPropiedad :tabsState="tabsState" @changeTab="tab = $event"></PublicarPropiedad>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card text>
                            <v-card-text>
                                <DespublicarPropiedad :tabsState="tabsState" @changeTab="tab = $event"></DespublicarPropiedad>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import AreasComunes from '@/pages/RealEstate/components/AreasComunes.vue'
import CaracteristicasInternas from '@/pages/RealEstate/components/CaracteristicasInternas.vue'
import CreateEditOwnerAdviser from '@/pages/RealEstate/components/CreateEditOwnerAdviser.vue'
import DatosDelInmueble from '@/pages/RealEstate/components/DatosDelInmueble.vue'
import DespublicarPropiedad from '@/pages/RealEstate/components/DespublicarPropiedad.vue'
import FotosVideos from '@/pages/RealEstate/components/FotosVideos.vue'
import Localizacion from '@/pages/RealEstate/components/Localizacion.vue'
import Portales from '@/pages/RealEstate/components/Portales.vue'
import PublicarPropiedad from '@/pages/RealEstate/components/PublicarPropiedad.vue'
import SitiosDeInteres from '@/pages/RealEstate/components/SitiosDeInteres.vue'
export default {
  components: {
    AreasComunes,
    CaracteristicasInternas,
    CreateEditOwnerAdviser,
    DatosDelInmueble,
    DespublicarPropiedad,
    FotosVideos,
    Localizacion,
    Portales,
    PublicarPropiedad,
    SitiosDeInteres
  },
  created () {
    this.$store.dispatch('getRealEstateAdvisers')
    this.$store.dispatch('getOwners')
  },
  data () {
    return {
      showCreateEditOwnerAdviser: false,
      tab: 0,
      tabsState: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
      ]
    }
  },
  methods: {
    updateStateForm (state) {
      this.$set(this.tabsState, state.tab, state.value)

      if (state.value) this.tab++
    }
  }
}
</script>
